import { SelectableOptionMenuItemType } from '@fluentui/react';
import { DropdownHeaderOption as HeaderOption } from './dropdown';

export const DropdownHeaderOption = (key: string, text: string): HeaderOption => ({
    itemType: SelectableOptionMenuItemType.Header,
    text,
    key,
});
